import { Trans, useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Stack } from '@koob/margaret';
import { KoobButton, KoobInputSelect, KoobModal, KoobTitle } from '@koob/ui';

export default function ExportLanguageModal({
  open,
  setOpen,
  locales,
  onSelectLanguage,
  defaultLocale,
}) {
  const { t } = useTranslation('tripDesigner');
  const [selectedLocale, setSelectedLocale] = useState(defaultLocale);

  // locales/defaultLocale load async — seed the select once they arrive so
  // the first Confirm click works instead of silently doing nothing.
  useEffect(() => {
    if (!selectedLocale && defaultLocale) {
      setSelectedLocale(defaultLocale);
    }
  }, [defaultLocale]);

  const handleConfirm = async () => {
    if (selectedLocale && onSelectLanguage) {
      onSelectLanguage(selectedLocale);
    }
  };

  return (
    <KoobModal
      open={open}
      setOpen={setOpen}
      allowClose={false}
      widthClass="sm:max-w-lg"
      overflow="visible"
    >
      <div className="flex flex-col items-center w-full p-6 overflow-visible">
        <div className="flex flex-col items-center gap-y-2 shrink-0">
          <div className="flex items-center justify-center w-11 h-11 rounded-full bg-orange-50">
            <i
              className="fa-light fa-globe text-orange-500"
              style={{ fontSize: 22 }}
            />
          </div>
          <KoobTitle>{t('travelDiarySettings:selectLanguage')}</KoobTitle>
          <p className="text-sm text-gray-500 text-center max-w-xs">
            <Trans
              t={t}
              i18nKey="travelDiarySettings:selectLanguageDescription"
              values={{ lang: defaultLocale?.label }}
              components={{ 1: <strong className="font-bold text-gray-900" /> }}
            />
          </p>
        </div>

        <div className="flex flex-col w-full mt-8 items-center overflow-visible">
          <div className="w-full flex justify-center overflow-visible">
            <KoobInputSelect
              searchable
              options={locales}
              value={selectedLocale?.value}
              onValueChange={(v) =>
                setSelectedLocale(locales.find((locale) => locale.value === v))
              }
              renderOption={(option) => (
                <Stack gutterSize={0.5} alignY="center" direction="row">
                  <span className={`flag-icon flag-icon-${option.alpha2}`} />
                  <span>{option.label}</span>
                </Stack>
              )}
              renderValue={(option) => (
                <Stack gutterSize={0.5} alignY="center" direction="row">
                  <span className={`flag-icon flag-icon-${option.alpha2}`} />
                  <span>{option.label}</span>
                </Stack>
              )}
              placeholder={t(
                'travelDiarySettings:selectLanguageModalPlaceholder',
              )}
            />
          </div>

          <div className="mt-12">
            <KoobButton
              variant="primary"
              disabled={!selectedLocale}
              onClick={handleConfirm}
            >
              {t('misc:confirm')}
            </KoobButton>
          </div>
        </div>
      </div>
    </KoobModal>
  );
}
